import clsx from 'clsx'
import { globalState } from '@/components/helpers/utils'

// Check if the domain and/or permanent domain is included in the url
// If so, replace it with the root url
const localiseURL = (url) => {
  const originalURL = new URL(url)
  if (globalState.shopify.domain || globalState.shopify.permanentDomain) {
    if (originalURL.hostname.includes(globalState.shopify.domain) || originalURL.hostname.includes(globalState.shopify.permanentDomain)) {
      return originalURL.toString().replace(originalURL.origin, globalState.routes.root)
    }
  }
  return url
}

export const NestedCollections = () => {
  const collection = window.collection
  const { nested_collections: nestedCollections = [] } = collection?.seo || {}
  if (!nestedCollections) return null
  const currentURL = window.location.href
  const localisedCurrentURL = localiseURL(currentURL)

  return (
      <>
      {nestedCollections.length > 0 && (
        <div className="flex items-center flex-grow gap-1 py-1 overflow-x-auto md:justify-end">
          {nestedCollections.map((link) => {
            const localisedLinkURL = localiseURL(link.url)
            return (
              <a
                className={clsx('btn btn-primary-text link btn-md paragraph-md whitespace-nowrap after:mx-3', localisedLinkURL === localisedCurrentURL && 'show-wavy-underline after:[--svg-color:theme(colors.brand.blue)] ')}
                href={localisedLinkURL}
                key={localisedLinkURL}
              >
                {link.text}
              </a>
            )
          })}
        </div>
      )}
      </>
  )
}
